<div class="main-box">
    <div class="login-main-box">
        <div class="left-box login-box">
            <div class="logo-box">
                <img class="img-fluid" src="../../../assets/images/White-logo.png" class="img-fluid">
            </div>
        </div>
        <div class="right-form-box login-box">
            <div class="login-form ">
                <div class="color-logo-box">
                    <img class="logo" src="../../../assets/images/logo.png">
                </div>
                <h3 class="bdrtitle">Welcome, Let's Get Started!</h3>
                <form nz-form [nzLayout]="'vertical'" [formGroup]="_fS.loginForm" (ngSubmit)="login()">
                    <nz-form-item>
                        <nz-form-label class="smlabel">Email Address</nz-form-label>
                        <nz-form-control nzErrorTip="Email is required">
                            <input nz-input class="custom-input" formControlName="email" placeholder="Enter Email Address" />
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label class="smlabel">Password</nz-form-label>
                        <nz-form-control nzErrorTip="Password is required">
                            <nz-input-group [nzSuffix]="suffixTemplate" class="password-input">
                                <input [type]="passwordVisible ? 'text' : 'password'" nz-input formControlName="password" placeholder="Enter Password" />
                            </nz-input-group>
                            <ng-template #suffixTemplate>
                                <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" (click)="passwordVisible = !passwordVisible"></i>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-control>
                            <button class="loginbtn" nz-button nzType="primary">Log in</button>
                        </nz-form-control>
                    </nz-form-item>
                </form>
            </div>
        </div>
    </div>
</div>
<nz-spin [nzSpinning]="_cS.isSpinning">
</nz-spin>